import { useEffect } from "react";

type PageMeta = {
  title: string;
  description: string;
  keywords?: string;
};

function setMetaTag(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMetaTag("description", description);
    if (keywords) setMetaTag("keywords", keywords);
  }, [title, description, keywords]);
}